"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for various Topic Update requests and responses.
 */
var UpdateStreamId = /** @class */ (function () {
    /**
     * Create a new UpdateStreamId instance
     *
     * @param topicId  the topic ID
     * @param instanceId  the instance ID
     * @param clustered  if the update stream Id belongs to a replicated topic
     * @param partitionId  the  partition ID
     * @param generationId  the generation ID
     */
    function UpdateStreamId(topicId, instanceId, clustered, partitionId, generationId) {
        this.topicId = topicId;
        this.instanceId = instanceId;
        this.clustered = clustered;
        this.partitionId = partitionId;
        this.generationId = generationId;
    }
    return UpdateStreamId;
}());
exports.UpdateStreamId = UpdateStreamId;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/update-stream-id.js
// module id = 1421
// module chunks = 1